import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import {
  citiesPage,
  sectorPage,
  statesPage
} from '@/__mocks__/modules/states/data.ts'

export default [
  {
    method: 'GET',
    path: '/states/catalog',
    reply: async () => {
      await wait()
      return [status.ok, statesPage]
    }
  },
  {
    method: 'GET',
    path: '/cities/catalog?page=1&state=1',
    reply: async () => {
      await wait()
      return [status.ok, citiesPage]
    }
  },
  {
    method: 'GET',
    path: '/sectors/catalog?page=1&city=104&state=1',
    reply: async () => {
      await wait()
      return [status.ok, sectorPage]
    }
  },
  {
    method: 'GET',
    path: '/sectors/catalog?page=1&state=1&city=104',
    reply: async () => {
      await wait()
      return [status.ok, sectorPage]
    }
  }
]
